import * as React from 'react'
import { styled } from '../../../theme/styled'
import { Property } from '../interfaces'
import { Typography } from '../../Typography'
import { ImageUnavailable } from '../../ImageUnavailable'

const MapDialog = styled.div`
  width: 13.5rem;
  position: absolute;
  top: -18rem;
  left: -24px;
  background: ${(p) => p.theme.av8.background};
  z-index: 2;
  border-radius: 4px;
  cursor: pointer;
`

const DialogImage = styled.div`
  width: 100%;
  height: 7.875rem;

  img {
    height: 100%;
    width: 100%;
    border-radius: 4px 4px 0 0;
    object-fit: cover;
  }
`

const DialogBody = styled.div`
  margin: 1rem;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

const Address = styled.span`
  font-size: 14px;
`

const Status = styled(Typography)<{ $status: string | undefined }>`
  font-size: 10px;
  line-height: 12px;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 2px;
  padding-bottom: 0.5rem;
  color: ${(p) => {
    switch (p.$status?.toUpperCase()) {
      case 'ACTIVE':
        return p.theme.av8.successColor
      case 'SOLD':
        return p.theme.av8.dangerColor
      default:
        return p.theme.av8.primaryColor
    }
  }};
`

const DetailsLine = styled.span`
  display: flex;
  justify-content: space-between;
`

const DetailText = styled(Typography)`
  font-size: 12px;
  line-height: 15px;
  &:last-child {
    padding-left: 8px;
    text-align: right;
  }
`

const DialogImageUnavailable = styled(ImageUnavailable)`
  height: 160px;
  grid-column: auto / span 1;
`

const MapPopover = (props: { property: Property['propertyData']; onClick?: () => void }) => {
  if (!props.property) return null
  const { cover, status, address, price, baths, beds, type, neighborhood } = props.property
  const bedsText = beds !== undefined ? `${beds}BD` : undefined
  const bathsText = baths !== undefined ? `${baths}BD` : undefined

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    props.onClick?.()
  }

  return (
    <MapDialog onClick={handleClick}>
      {cover ? (
        <DialogImage>
          <img src={cover} alt='property-cover' />
        </DialogImage>
      ) : (
        <DialogImageUnavailable message='Image unavailable' />
      )}
      <DialogBody>
        <Address>{address}</Address>
        <Status $status={status}>{status}</Status>
        <DetailsLine>
          <DetailText>{price && `$${price.toLocaleString('en-US')}`}</DetailText>
          <DetailText color='secondary'>
            {bedsText}
            {bedsText && bathsText && ' | '}
            {bathsText}
          </DetailText>
        </DetailsLine>
        <DetailsLine>
          <DetailText>{type}</DetailText>
          <DetailText>{neighborhood}</DetailText>
        </DetailsLine>
      </DialogBody>
    </MapDialog>
  )
}
export default MapPopover
